import { useMutation } from '@tanstack/react-query';
import { documentService, CreateDocumentPayload } from '@services/document';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateDocument = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['documents', 'create'],
    mutationFn: async (payload: CreateDocumentPayload) => {
      return await documentService.createDocuments(payload);
    },
    onSuccess: () => {
      toast.success(tActionMessages.documentUploadedSuccessfully);

      // Invalidate relevant queries to refresh the UI
      queryClient.invalidateQueries({ queryKey: ['documents'] });
      queryClient.invalidateQueries({ queryKey: ['project'] });
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
    onError: (error: any) => {
      console.error('Document creation error:', error);
      toast.error(
        getErrorMessage(error, 'Failed to upload documents. Please try again.'),
      );
    },
  });
};

export default useCreateDocument;
